import React from "react"
import LearningBoxListState, { LearningBoxListProps } from "./LearningBoxList.models";
import './LearningBoxList.scss';
import LeitnerBox from "../shared/leitner-box/LeitnerBox";
import { LeitnerBoxView } from "../shared/leitner-box/LeitnerBox.models";
import NotFoundData from "../shared/not-found-data/NotFoundData";
import NotFoundCover from "../../assest/images/Empty-Illustration.png";
import { NavLink } from "react-router-dom";
import costumImage from "../../assest/images/leitner/LethnerBG-Custom.svg";

export default class LearningBoxList extends React.PureComponent<LearningBoxListProps, LearningBoxListState> {
    constructor(props: LearningBoxListProps) {
        super(props);
        this.state = { leitnerBoxs: [] };
    }

    componentDidMount() {
        this.setState({ leitnerBoxs: this.props.leitnerBoxs })
    }

    componentDidUpdate(prevProps: LearningBoxListProps) {
        if (prevProps.leitnerBoxs !== this.props.leitnerBoxs)
            this.setState({ leitnerBoxs: this.props.leitnerBoxs })
    }

    render(): React.ReactNode {
        let { leitnerBoxs } = this.state;
        let { config } = this.props;


        return <>
            {this.leitnersView(leitnerBoxs)}
            {this.footerViwe(config.hasPlusButton, config.navigateLink ?? "")}
        </>;
    }

    footerViwe(hasPlusButton: boolean, navigateLink: string) {

        let content;
        if (hasPlusButton)
            content = <>
                <NavLink to={navigateLink}>
                    <label className="btn-success-leitner">لایتنر جدید <i className="mdi mdi-plus"></i></label>
                </NavLink>
            </>;
        else content = <></>;

        return <>
            {content}
        </>
    }

    leitnersView(boxs: LeitnerBoxView[]) {
        let content;
        let myLeitner;

        if (this.props.config.showMyLeitnerRedirector)
            myLeitner = <LeitnerBox boxDetail={{ title: "لایتنر های من", imageSource: costumImage, redirectLink: "/CustomBoxs" }} />
        else myLeitner = <></>;

        if (boxs !== null && boxs !== undefined) {
            var redirectorLink = this.props.config.showMyLeitnerRedirector ? "/LeitnerBox" : "/CustomBoxInformation";

            content = <>
                {
                    boxs.map((box, key) => {
                        return <LeitnerBox boxDetail={{ imageSource: box.imageSource, title: box.title, redirectLink: redirectorLink + "?boxId=" + box.redirectLink }} key={key} />;
                    })
                }
                {myLeitner}
            </>
        }
        else
            content = <NotFoundData image={NotFoundCover} title="هنوز جعبه لاینتر درست نکرده اید" subTitle="برای ساخت جعبه لایتنر، دکمه ی لایتنر جدید را لمس کنید"
                config={{ subTitleClass: "not-found-sub-title", titleClass: "not-found-title", height: '', width: '' }} />

        return <>
            {content}
        </>
    }
}